export default __webpack_public_path__ + "images/6f1b1a6210d0eb6209902a9604169aa5-soccer_small.webp";